module.exports = __webpack_public_path__ + "static/media/PC6-2.9dd4d0b9.jpg";